import { render, staticRenderFns } from "./GreetingToast.vue?vue&type=template&id=13dfad5e&scoped=true"
import script from "./GreetingToast.vue?vue&type=script&lang=js"
export * from "./GreetingToast.vue?vue&type=script&lang=js"
import style0 from "./GreetingToast.vue?vue&type=style&index=0&id=13dfad5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dfad5e",
  null
  
)

export default component.exports